import React from "react";

const events = [
    {
        time: "15:00",
        title: "Ceremonia ślubna",
        desc: "Parafia św. Andrzeja Boboli\nGąsiory 24, Ulan-Majorat",
        icon: "⛪",
        color: "dy",
        side: "left",
    },
    {
        time: "17:00",
        title: "Przyjęcie weselne",
        desc: "Hotel & Restauracja President\nAperitif, powitanie gości",
        icon: "🥂",
        color: "dg",
        side: "right",
    },
    {
        time: "~18:10",
        title: "Pierwszy taniec",
        desc: "Klaudia & Bartłomiej\nTaniec pary młodej",
        icon: "💃",
        color: "do_",
        side: "left",
    },
    {
        time: "~00:00",
        title: "Oczepiny",
        desc: "Tradycyjne oczepiny\ni zabawa taneczna",
        icon: "🎉",
        color: "dp",
        side: "right",
    }
];

function Timeline() {
    return (
        <div className="schedule" id="harmonogram">
            <div className="sched-inner">
                <div className="sched-head">
                    <div className="eyebrow lime" style={{ justifyContent: "center" }}>
                        Plan dnia
                    </div>
                    <h2 className="sec-title" style={{ textAlign: "center" }}>
                        Harmonogram<br />
                        <em>15 sierpnia 2026</em>
                    </h2>
                </div>

                <div className="timeline">

                    {events.map((event, index) => (
                        <div
                            key={index}
                            className={`tl-row ${event.side === "right" ? "flip" : ""}`}
                        >
                            {/* Lewa strona */}
                            <div className={`tl-l ${event.side === "left" ? "tl-content" : "tl-empty"}`}>
                                {event.side === "left" && (
                                    <>
                                        <div className="tl-name">{event.title}</div>
                                        <div className="tl-desc">
                                            {event.desc.split("\n").map((line, i) => (
                                                <span key={i}>{line}<br /></span>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>

                            {/* Środek — ikona i czas */}
                            <div className="tl-c">
                                <div className={`tl-dot ${event.color}`}>{event.icon}</div>
                                <div className="tl-time">{event.time}</div>
                            </div>

                            {/* Prawa strona */}
                            <div className={`tl-r ${event.side === "right" ? "tl-content" : "tl-empty"}`}>
                                {event.side === "right" && (
                                    <>
                                        <div className="tl-name">{event.title}</div>
                                        <div className="tl-desc">
                                            {event.desc.split("\n").map((line, i) => (
                                                <span key={i}>{line}<br /></span>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Timeline;